﻿var mmsystem = mmsystem || {};
mmsystem.payments = mmsystem.payments || {};

//Requires https://js.stripe.com/v3/
//Requires MissionSystem.CustomScripts.Utilities

mmsystem.utilities = require('mmsystem-utilities');
var stripeAjax = require('mmsystem-payments-stripe-ajax');
var events = require('events');

mmsystem.payments.stripe = {

    //Ajax
    ajax: stripeAjax,

    EventEmitter: new events.EventEmitter(),

    Settings: {},
    Order: {},
    User: {},
    LocalisedStrings: new Array(),
    Language: "En",
    LanguageUrlPrefix: "En",
    UseGlobalization: false,

    //Stripe
    PublishableAPIKey: '',
    CardElementId: '',
    CardErrorElementId: '',
    RequestButtonElementId: '',

    StripePayment: {},
    StripeElements: {},
    StripeCard: {},
    StripePaymentRequest: {},
    StripePaymentRequestButton: {},
    StripePaymentRequestButtonCreated: false,

    StripeFunctions: {
        IsLive: false,
        PaymentResponseEvent: {},
        PaymentMethodId: "",
        PaymentIntentId: "",
        PaymentType: "",
        ConfirmPayment: false,
        UpdateBillingFromPayment: false,
        ConstPaymentTypes: {
            Stripe: 'Stripe',
            StripeGoogle: 'StripeGoogle',
            StripeApple: 'StripeApple'
        }
    },

    Init: function (settings) {

        //console.log('mmsystem.payments.stripe.init ...');
        //console.log(settings);

        this.Settings = settings;
        this.Order = settings.Order;
        this.LocalisedStrings = settings.LocalisedStrings;
        this.LanguageUrlPrefix = settings.LanguageUrlPrefix;
        this.Language = settings.Language;

        this.PublishableAPIKey = settings.Stripe.PublishableAPIKey;
        this.AccountCountry = settings.Stripe.AccountCountry;
        this.CardElementId = settings.Stripe.CardElement;
        this.CardErrorElementId = settings.Stripe.CardErrorElement;
        this.RequestButtonElementId = settings.Stripe.RequestButtonElementId;

        //Init Ajax for Stripe
        mmsystem.payments.stripe.ajax.Init(this.Settings);

        // Add Functions
        this.AddFunctions();

        //Create Stripe Object
        this.StripePayment = Stripe(this.PublishableAPIKey);

        //Setup
        this.StripeFunctions.IsLive = (this.StripePayment._keyMode == "live") ? true : false;

        //Get PaymentIntent
        this.StripeFunctions.PaymentIntentId = settings.Stripe.PaymentIntentId;

        //Elements
        var stripeLanguage = this.Language.toLowerCase();
        stripeLanguage = stripeLanguage == 'cn' ? 'zh' : stripeLanguage;
        this.StripeElements = this.StripePayment.elements({
            locale: stripeLanguage
        });

        // Custom styling can be passed to options when creating an Element.
        var style = {
            base: {
                // Add your base input styles here. For example:
                backgroundColor: '#f9f9f9',
                fontSize: '1.1em',
                color: '#10113A',
                '::placeholder': {
                    color: '#979abf'
                },
                lineHeight: '3em',
                padding: '0 3em 0 3em'
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        //Check card Element
        var isStripeCardExist = false;
        for (var key in this.StripeCard) {
            if (this.StripeCard.hasOwnProperty(key)) {
                isStripeCardExist = true;
                break;
            }
        }

        if (isStripeCardExist)
            this.StripeCard.destroy();

        // Create an instance of the card Element
        this.StripeCard = this.StripeElements.create('card', { style: style, hidePostalCode: true });

        // Add an instance of the card Element into the `card-element` <div>
        this.StripeCard.mount('#' + this.CardElementId);

        // Add Listeners
        this.AddListeners();

    },

    CreatePaymentMethod: function (type) {
        this.StripePayment.createPaymentMethod(type, this.StripeCard, this.StripeFunctions.GetPaymentMethodData()).then(function (result) {
            mmsystem.payments.stripe.EventEmitter.emit('CreatePaymentMethodComplete', result);
            
        });
    },

    CreatePaymentRequest: function () {
        this.StripePaymentRequest = this.StripePayment.paymentRequest(this.StripeFunctions.GetPaymentRequestData());
    },

    UpdatePaymentRequest: function () {
        this.StripePaymentRequest.update(this.StripeFunctions.GetPaymentRequestData());
    },

    CreatePaymentRequestButton: function () {
        var requestButtonStyle = {
            paymentRequestButton: {
                type: 'default',// | 'donate' | 'buy', // default: 'default'
                theme: 'light-outline',// | 'light' | 'light-outline', // default: 'dark'
                height: '40px', // default: '40px', the width is always '100%'
            }
        }

        this.StripePaymentRequestButton = this.StripeElements.create('paymentRequestButton', {
            paymentRequest: mmsystem.payments.stripe.StripePaymentRequest,
            style: requestButtonStyle
        });

        // Check the availability of the Payment Request API first.
        this.StripePaymentRequest.canMakePayment().then(function (result) {
            if (result) {
                if (result.applePay) {
                    mmsystem.payments.stripe.StripeFunctions.PaymentType = mmsystem.payments.stripe.StripeFunctions.ConstPaymentTypes.StripeApple; //"StripeApple";
                }
                else {
                    mmsystem.payments.stripe.StripeFunctions.PaymentType = mmsystem.payments.stripe.StripeFunctions.ConstPaymentTypes.StripeGoogle; //"StripeGoogle";
                }

                //Mount Button
                mmsystem.payments.stripe.StripePaymentRequestButton.mount('#' + mmsystem.payments.stripe.RequestButtonElementId);
                mmsystem.payments.stripe.StripePaymentRequestButtonCreated = true;
            } else {

                $('#' + mmsystem.payments.stripe.RequestButtonElementId).hide();
            }
            //console.log('canMakePayment: ');
            //console.log(result);
        });

        //console.log(mmsystem.payments.stripe.StripePaymentRequest);
    },

    AddListeners: function () {

        //$(this).bind("stripeCardDetailsChanged");
        //$(this).bind("stripeCardReady");
        //$(this).bind("paymentStripeComplete");

        //Card Change Listener
        this.StripeCard.on('change', function (event) {
            //$(mmsystem.payments.stripe).trigger("stripeCardDetailsChanged", event);
            mmsystem.payments.stripe.EventEmitter.emit("stripeCardDetailsChanged", event);

            mmsystem.payments.stripe.ToggleCardEvent(event);

        });

        //Card Ready
        this.StripeCard.on('ready', function (event) {
            //$(mmsystem.payments.stripe).trigger("stripeCardReady", event);
            mmsystem.payments.stripe.EventEmitter.emit("stripeCardReady", event);
        });
    },

    AddFunctions: function () {

        this.StripeFunctions.GetPaymentMethodData = function () {
            var order = mmsystem.payments.stripe.Order;
            var data = {};
            if (order.BillingAddress) {

                data.billing_details = {
                    name: order.BillingAddress.FirstName + ' ' + order.BillingAddress.LastName,
                    address: {
                        line1: order.BillingAddress.Street,
                        line2: order.BillingAddress.Number,
                        city: order.BillingAddress.City,
                        postal_code: order.BillingAddress.PostCode,
                        country: order.BillingAddress.CountryISO
                    },
                    email: order.User.Email
                };
            }

            return data;
        };

        this.StripeFunctions.GetPaymentRequestData = function (includeAccountCountry) {
            var order = mmsystem.payments.stripe.Order;
            var data = {};
            data = {
                currency: order.Currency.toLowerCase(),
                total: {
                    label: 'Order Total',
                    amount: Math.floor(order.PriceTotal * 100) // remove decimals,
                },
                displayItems: mmsystem.payments.stripe.StripeFunctions.GetStripeOrderItems()
            };

            if (includeAccountCountry)
                data.country = order.AccountantCountry; //The two-letter country code of your Stripe account
            else
                data.country = mmsystem.payments.stripe.AccountCountry;

            return data;
        };

        this.StripeFunctions.GetStripeOrderItems = function () {
            var order = mmsystem.payments.stripe.Order;
            var Items = [];
            $.each(order.Items, function (index, obj) {
                var item = { label: obj.Product.Name, amount: Math.floor(obj.PriceTotal * 100) }; // remove decimals
                Items[index] = item;
            });

            if (order.Insurance != null && order.Insurance.Id > 0) {
                var item = { label: "Insurance", amount: Math.floor(order.Insurance.Price * 100) }; // remove decimals
                Items[Items.length] = item;
            }

            if (order.Delivery != null && order.Delivery.Id > 0) {
                var item = { label: (order.Delivery.IsFree == true ? 'Free Delivery - ' + order.Delivery.Name : 'Delivery - ' + order.Delivery.Name), amount: Math.floor(order.Delivery.Price * 100) }; // remove decimals
                Items[Items.length] = item;
            }

            return Items;
        };
    },

    DestroyCardElement: function () {
        this.StripeCard.destroy();
    },

    ToggleCardEvent: function (event) {
        //console.log('ToggleCardError..');
        //console.log(event);

        if (event.complete) {
            // enable payment button
            this.HideErrorElement();
        } else if (event.error) {
            // show validation to customer
            this.ShowErrorElement(event.error.message);
        }

    },

    ShowErrorElement: function (message) {
        this.GetErrorElement().text(message);
    },

    HideErrorElement: function () {
        this.GetErrorElement().text('');
    },

    GetErrorElement: function () {
        return $('#' + mmsystem.payments.stripe.CardErrorElementId);
    },


};


//Node exports
module.exports = mmsystem.payments.stripe;

// Hot Module Accept
if (module.hot) {
    module.hot.accept();
}
